var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _rect2, _path11, _path12, _path13, _path14, _ellipse, _rect3, _path15, _path16, _path17, _ellipse2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 476,
    viewBox: "0 0 314 476",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.4727 203.478L128.973 272.471L347.473 108.988V0L89.4727 203.478Z",
    fill: "#FFEED7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253.989 157.23H279.143H280.793V187.33H253.989V157.23Z",
    fill: "#FFAD3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4727 345.965H318.473V279.972H79.7096C56.9351 279.972 38.4727 298.434 38.4727 321.209V345.965Z",
    fill: "#C6DDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M266.236 262.661L232.415 274.626L186.839 261.931C176.916 259.168 166.295 260.154 157.185 265.099C152.298 267.755 147.999 271.282 146.772 275.766L177.32 271.777L192.048 272.917L248.234 308.244L285.328 295.708L266.236 262.661Z",
    fill: "#08BD80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M260.473 369.961H340.473V246.615C340.473 235.766 332.215 226.977 322.034 226.977H260.473V369.961Z",
    fill: "#A6F1D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M284.916 238.87C291.975 238.87 297.699 232.777 297.699 225.263V211.656H272.132V225.263C272.132 232.777 277.856 238.87 284.916 238.87Z",
    fill: "#FFAD3B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M251.24 155.582L244.917 189.337H251.24V211.658H282.855",
    fill: "#FFAD3B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M249.039 148.984V155.165C249.039 161.4 254.032 166.456 260.191 166.456C264.753 166.456 268.452 170.201 268.452 174.82V228.151H305.121V169.628C305.121 158.228 295.992 148.984 284.732 148.984H249.039Z",
    fill: "#3C4852"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M307.598 297.463L241.632 324.738L187.116 276.906L146.773 276.867C146.773 276.867 154.951 263.508 173.487 263.508C187.661 263.508 195.293 266.848 195.293 266.848L243.268 289.113L307.598 257.941V297.463Z",
    fill: "#A6F1D8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M197.184 273.161L129.307 272.07L90.4727 202.477L82.8092 207.385L123.439 280.425L197.184 282.978V273.161Z",
    fill: "#EB5757"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 259,
    height: 72.9922,
    transform: "matrix(1 0 0 -1 184.473 475.949)",
    fill: "#FFEED7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 259,
    height: 33.9964,
    transform: "matrix(1 0 0 -1 184.473 436.953)",
    fill: "#FFAD3B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M130.973 437.953L184.473 475.449V402.957L130.973 437.953Z",
    fill: "#FFAD3B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.973 437.953L184.473 475.449V436.953L130.973 437.953Z",
    fill: "#FFEED7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.973 437.954L144.473 447.453V428.955L130.973 437.954Z",
    fill: "#3C4852"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M260.473 475.95H330.473V428.183C330.473 396.029 299.131 369.961 260.473 369.961V475.95Z",
    fill: "#FFCDCD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.473,
    cy: 436.955,
    rx: 22,
    ry: 21.9977,
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 438.137,
    width: 104.333,
    height: 9.48384,
    fill: "#2D81F7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79297 438.135V421.957C18.8826 424.042 34.4182 429.215 48.546 437.192L50.2172 438.135H2.79297Z",
    fill: "#FFDBA9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M102.66 438.135V421.957C86.5705 424.042 71.0349 429.215 56.9072 437.192L55.2359 438.135H102.66Z",
    fill: "#FFDBA9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4484 453.761C56.4542 453.761 59.7016 450.514 59.7016 446.508H45.1953C45.1953 450.514 48.4426 453.761 52.4484 453.761Z",
    fill: "#2D81F7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.973,
    cy: 30.4973,
    rx: 25.5,
    ry: 25.4973,
    fill: "#2D81F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl);
export default __webpack_public_path__ + "static/media/girl.bf4ad3786972aa9ede1cd785444f914b.svg";
export { ForwardRef as ReactComponent };